export default (theme) => {
  return {
    mainContainer: ({
      width,
      height,
      color,
      align,
    }) => {
      const alignStyle = align === 'center' ? {
        left: '50%',
        transform: 'translateX(-50%)',
        position: 'absolute',
      } : {}

      return {
        ...alignStyle,
        width,
        height,
        borderRadius: height,
        backgroundColor: theme.palette.common[color],
      }
    },
  }
}
